export default "__VITE_ASSET__CdqJ9xGA__"